module.exports = __webpack_public_path__ + "img/5-3.1bee39c9.png";